import { ArrowRightIcon, type ArrowRightIconProps } from "@/components/atoms/icons/ArrowRightIcon";
import { useI18nContext } from "@/core/providers/I18nProvider";
import React from "react";
import { View } from "react-native";

/**
 * "Forward" arrow that points left in Arabic. The root `direction: 'rtl'`
 * mirrors layout but never an icon's glyph, so the flip is done here.
 * Takes `color` directly (not via a wrapper) so Button's cloneElement on
 * `trailing` can still recolor it.
 */
export function DirectionalArrowIcon(props: Readonly<ArrowRightIconProps>) {
  const { isRTL } = useI18nContext();
  return (
    <View style={isRTL ? RTL_FLIP : undefined}>
      <ArrowRightIcon {...props} />
    </View>
  );
}

const RTL_FLIP = { transform: [{ scaleX: -1 }] };

export default DirectionalArrowIcon;
